export function detectDevice(): "android" | "ios" | "desktop" {
  if (typeof window === "undefined") return "desktop"

  const ua = navigator.userAgent.toLowerCase()

  if (/android/.test(ua)) {
    return "android"
  }

  if (/iphone|ipad|ipod/.test(ua)) {
    return "ios"
  }

  return "desktop"
}

export function getStoreUrl(device: "android" | "ios"): string {
  if (device === "android") {
    return "https://play.google.com/store/apps/details?id=ru.taximaster.tmtaxicaller.id3052&pcampaignid=web_share"
  }
  return "https://apps.apple.com/uz/app/cardin-taxi/id6670791817"
}
